import React from 'react';
import {useContext} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { AuthContext } from '../UserContext/AuthProvider';

const Profile = () => {
	const {user}= useContext(AuthContext)
	return (
		<section>
			<div className="container py-5">
				<div className="row">
					<div className="col-md-4 offset-md-4">
						<Form>
							<Form.Group className="mb-3" controlId="formBasicEmail">
								<Form.Label>Username</Form.Label>
								<Form.Control type="text" defaultValue={user?.displayName} placeholder="Enter email" />
							</Form.Group>
							<Form.Group className="mb-3" controlId="formBasicEmail">
								<Form.Label>Email address</Form.Label>
								<Form.Control defaultValue={user?.email} type="email" placeholder="Enter email" />
							</Form.Group>
							<Form.Group className="mb-3" controlId="formBasicEmail">
								<Form.Label>Profile Picture</Form.Label>
								<Form.Control type="text" defaultValue={user?.photoURL} placeholder="Enter email" />
							</Form.Group>
							
							<Button className='w-100 bg-black py-2' type="submit">
								Submit
							</Button>
							</Form>
  
					</div>
				</div>
			</div>
		</section>
	);
};

export default Profile;